import TreatmentGroups from './TreatmentGroups';

export default TreatmentGroups;
